import React, { useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { selPendUser } from "../../../users-management/slice/userSlice";
import { useForm } from "hooks";
import { TextField } from "app/components/common/TextField";
import {
  HomeBaseSelector,
  PermissionGroupsSelector,
} from "../../../users-management/components/common";
import { forwardRef } from "react";
import { addUserAssignments } from "../../slice/userAssignmentThunks";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles(
  (theme) => ({
    gridContainer: {},
  }),
  { name: "PendUserAssignments" }
);
/* -------------------------------------------------------------------------- */
const initialAssignment = {
  homebase_one: "",
  airline_groups: [],
  code: "",
  known_as: "",
};
/* -------------------------------------------------------------------------- */
const UserAssignments = forwardRef(({ onSubmit, onLoading }, ref) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const pendData = useSelector(selPendUser);
  const { user } = pendData;
  const { data, errors, handleChange, handleSubmit } = useForm({
    initialValues: initialAssignment,
    validations: {
      homebase_one: {
        required: {
          value: true,
          message: "This field is required!",
        },
      },
      airline_groups: {
        required: {
          value: true,
          message: "This field is required!",
        },
        custom: {
          isValid: (value) => Array.isArray(value) && value.length > 0,
          message: () => "This field is required!",
        },
      },
      code: {
        required: {
          value: true,
          message: "This field is required!",
        },
        custom: {
          isValid: (value) => {
            return value?.length > 2;
          },
          message: () => "Enter minimum 3 characters",
        },
      },
      known_as: {
        required: {
          value: true,
          message: "This field is required!",
        },
      },
    },
    onSubmit: () => {
      acceptUser();
    },
  });
  /* -------------------------------------------------------------------------- */
  useImperativeHandle(ref, () => ({
    submit(callback) {
      handleSubmit(callback);
    },
  }));
  /* --------------------------------- Accept --------------------------------- */
  const acceptUser = () => {
    onLoading(true);
    dispatch(
      addUserAssignments(
        {
          airline: pendData.airline.id,
          airline_groups: data.airline_groups,
          //crew_id: "1",
          job_title: pendData.job_title,
          code: data.code,
          homebases: [data.homebase_one],
          email: user.email,
          known_as: data.known_as,
        },
        user.id,
        onCallback
      )
    );
  };
  const onCallback = (error, message) => {
    if (error) {
      toast.error(message || "Failed to accept user");
    } else {
      onSubmit();
      history.push(`users/${user.id}`);
    }
    onLoading(!error);
  };
  /* -------------------------------------------------------------------------- */
  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={6}>
        <PermissionGroupsSelector
          multiple
          label="Permission groups*"
          values={data.airline_groups}
          onChange={handleChange("airline_groups")}
          error={errors.airline_groups}
        />
      </Grid>
      <Grid item xs={6}>
        <HomeBaseSelector
          label={"Homebase 1*"}
          selected={data.homebase_one}
          disabledOption={data.homebase_two}
          error={errors.homebase_one}
          onChange={handleChange("homebase_one")}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Known as*"
          value={data.known_as}
          error={errors.known_as}
          onChange={handleChange("known_as", textfieldSanitize)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Code*"
          value={data.code}
          error={errors.code}
          onChange={handleChange("code", textfieldSanitize)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField label="Email" value={user.email} readOnly />
      </Grid>
    </Grid>
  );
});
export default UserAssignments;
/* -------------------------------------------------------------------------- */
function textfieldSanitize(e) {
  return e.target.value;
}
